import FormikInputField from './formik-input-field';

export default FormikInputField;
